module.exports = __webpack_public_path__ + "static/screenie_search_5-ec8b9d9dbde3366928f199e6e0ece39b.jpg";